<template>
  <section class="hero gradient-bg" id="home">
    <div class="hero-content">
      <h1 class="gradient-text">{{ title }}</h1>
      <p>{{ description }}</p>
      <div class="hero-buttons">
        <router-link to="/equipment" class="cta-button btn-hover primary">Browse Equipment</router-link>
        <a href="#products" class="cta-button btn-hover secondary">Learn More</a>
      </div>
    </div>
    <div class="hero-particles">
      <div v-for="i in 20" :key="i" class="particle" :style="getParticleStyle(i)"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    title: String,
    description: String
  },
  methods: {
    getParticleStyle(index) {
      return {
        left: Math.random() * 100 + '%',
        animationDelay: Math.random() * 3 + 's',
        animationDuration: (Math.random() * 2 + 2) + 's'
      }
    }
  }
}
</script>

<style scoped>
.hero {
  color: white;
  padding: 8rem 2rem 6rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 3;
}

.hero h1 {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  font-weight: 300;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.hero p {
  font-size: 1.4rem;
  margin-bottom: 3rem;
  opacity: 0.95;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.cta-button {
  display: inline-block;
  background: rgba(255,255,255,0.95);
  color: #2c5aa0;
  padding: 1.2rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.2);
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  background: rgba(255,255,255,1);
}

.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 3rem;
}

.hero-buttons .cta-button {
  padding: 1rem 2.5rem;
  font-size: 1rem;
}

.hero-buttons .primary {
  background: rgba(255,255,255,0.95);
  color: #2c5aa0;
  border: 1px solid rgba(255,255,255,0.2);
}

.hero-buttons .primary:hover {
  background: rgba(255,255,255,1);
}

.hero-buttons .secondary {
  background: rgba(255,255,255,0.95);
  color: #4a7bc8;
  border: 1px solid rgba(255,255,255,0.2);
}

.hero-buttons .secondary:hover {
  background: rgba(255,255,255,1);
}

.hero-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255,255,255,0.3);
  border-radius: 50%;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 0.8;
  }
}

.gradient-bg {
  background: linear-gradient(-45deg, #2c5aa0, #4a7bc8, #6b9ce8, #2c5aa0);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gradient-text {
  background: linear-gradient(45deg, #ffffff, #e3f2fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .hero {
    padding: 6rem 1rem 4rem;
    min-height: 80vh;
  }
  
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .hero p {
    font-size: 1.1rem;
  }
  
  .cta-button {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero h1 {
    font-size: 2rem;
  }
  
  .hero p {
    font-size: 1rem;
  }
}
</style> 